<app-select
  class="inbox-site-selector"
  [control]="sitesCtrl"
  [items]="dropdownItems.sites"
  [itemsMap]="dropdownItems.sitesMap"
  [multiple]="true"
  [identifier]="'key'"
  [optionTemplateName]="'site-icon'"
  [labelKey]="'account'"
  [noFloatingLabel]="true"
  [panelClass]="'inbox'"
  [formFieldClass]="'no-vertical-padding'"></app-select>
